// src/components/common/ConfirmDialogBody.js
//
// ConfirmDialog's scrollable body: message + optional bodyNode + the
// attestation panel. Extracted from ConfirmDialog.js (Task 2 · WAVE 1 ·
// ENGINE, 2026-09-24) to keep the parent under the 500-line cap once the
// checking-state AutoHeight wrap landed — zero behavior change for every
// caller that never sets `checking`.
//
// `openedChecking` is a REF VALUE the caller captured ONCE, at the dialog's
// first render (not the live `checking` flag) — so the AutoHeight wrapper
// (and its ResizeObserver) mounts only for a dialog instance that started in
// checking mode. Every other dialog renders the same two children directly,
// byte-identical to before this landed.

import AutoHeight from './AutoHeight';
import ConfirmAttestationBlock from './ConfirmAttestationBlock';
import { modalBodyScrollRegion } from '../../ui/overlayStyles';
import { foundation } from '../../ui/tokens';

const { spacePx } = foundation;

export default function ConfirmDialogBody({
  message,
  messageStyle,
  bodyNode,
  hasTypedField,
  /** Ref VALUE — was `checking` true at THIS instance's first render? */
  openedChecking,
  /** Live `checking` flag — hides the attestation panel while a pre-check runs. */
  checking,
  attestation,
  attested,
  setAttested,
  busy,
  /** Optional section rendered inside the scroll region after the message/body (preset reason picker). */
  children = null,
}) {
  const messageAndBodyNode = (
    <>
      {message ? <p style={messageStyle}>{message}</p> : null}
      {bodyNode ? (
        <div style={{ marginBottom: hasTypedField ? spacePx[2] : spacePx[3] }} data-testid="confirm-dialog-body">
          {bodyNode}
        </div>
      ) : null}
    </>
  );

  return (
    <div style={modalBodyScrollRegion}>
      {openedChecking ? <AutoHeight>{messageAndBodyNode}</AutoHeight> : messageAndBodyNode}
      {children}
      <ConfirmAttestationBlock
        attestation={checking ? null : attestation}
        attested={attested}
        setAttested={setAttested}
        busy={busy}
        hasTypedField={hasTypedField}
      />
    </div>
  );
}
